import { useEffect } from 'react'

import type { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'

import {
  BankLevelSecurity,
  BrighterFuture,
  FAQLodge,
  FeaturesGrid,
  HowToStart,
  InstantCash,
  PersonalizedEarning,
  Testimonials,
  TransformCTA,
  TrustedBy,
} from '@ui/components/lodge'
import { Seo } from '@ui/components/seo'
import { HeroCashRewardsLodge } from '@ui/hero/HeroCashRewardsLodge'

import { AuthCard } from '@web-app/components/auth/AuthCard'
import { WebMarketingLayout } from '@web-app/components/layout'
import { useEventTracking } from '@web-app/context/EventTrackingContext'
import { withSession } from '@web-app/hoc/withSession'
import { safeInternalRedirect } from '@web-app/utils/auth/loginRedirect'

const title = 'ATM.com - Earn Money - Real Cash Rewards'
const description =
  'Earn extra cash through paid surveys, games, featured offers, and daily rewards.'

const IndexPage = () => {
  const router = useRouter()
  const redirect = safeInternalRedirect(router.query.redirect)

  const { trackEvent } = useEventTracking()

  useEffect(() => {
    trackEvent('view_index', { comp: 'IndexPage' })
  }, [])

  return (
    <>
      <Seo title={title} description={description} />
      <WebMarketingLayout bg="light-blue">
        <HeroCashRewardsLodge
          className="mx-auto max-w-7xl overflow-hidden pt-12"
          title={
            <>
              Earn{' '}
              <span className="text-[#29bfed] sm:whitespace-pre">
                Real Cash{' '}
              </span>
              Today, No Hassle
            </>
          }
          description={
            'Earn extra cash through surveys, games, and exclusive offers all in one app.'
          }
          form={<AuthCard redirect={redirect} />}
        />
        {/* Trusted by Brands Section */}
        <TrustedBy />
        {/* A Brighter Financial Future Section */}
        <BrighterFuture />
        {/* Features Grid Section */}
        <FeaturesGrid />
        {/* Instant Cash Section with Details */}
        <InstantCash />
        {/* Personalized Earning Section */}
        <PersonalizedEarning />
        {/* Bank-Level Security Section */}
        <BankLevelSecurity />
        {/* Testimonials Section */}
        <Testimonials />
        {/* How to Start Section */}
        <HowToStart />
        {/* Ready to Transform CTA Section */}
        <TransformCTA />
        {/* FAQ Section */}
        <FAQLodge />
      </WebMarketingLayout>
    </>
  )
}

export const getServerSideProps: GetServerSideProps = withSession(
  async () => ({ props: {} }),
  { access: 'guest' },
)

export default IndexPage
